// Claim labels and colors shared by the Claims page and the Split Order modal. Keep this file free of app hooks
// and Firebase imports so any component (and its tests) can import it.
import { colors } from '@/styles';

/** Display text for each `claims.claim_status` value (`ACCEPTED` reads "Approved"). */
export const CLAIM_STATUSES = {
    SUBMITTED: 'Submitted',
    INVESTIGATING: 'Investigating',
    PRE_APPROVED: 'Pre-Approved',
    ACCEPTED: 'Approved',
    REJECTED: 'Rejected',
    CLOSED: 'Closed',
};

/** Accent color for each `claims.claim_status` value, used for status tags. */
export const CLAIM_STATUS_COLORS = {
    SUBMITTED: colors.greys.secondary,
    INVESTIGATING: colors.blues.primary,
    PRE_APPROVED: colors.oranges.primary,
    ACCEPTED: colors.greens.primary,
    REJECTED: colors.reds.primary,
    CLOSED: colors.reds.primary,
};

/** Display text for each `claims.claim_type` value. */
export const CLAIM_TYPES = {
    FREIGHT: 'Freight',
    PROPERTY_DAMAGE: 'Property Damage',
    SERVICE_FAILURE: 'Service Failure',
};

/** What a claim item is called for each `claims.claim_type`: an item, or a service for a service failure. */
export const ITEM_TYPE_LABELS = {
    FREIGHT: 'Item',
    PROPERTY_DAMAGE: 'Item',
    SERVICE_FAILURE: 'Service',
};

/** The reasons offered for a claim item, by `claims.claim_type`. */
export const ITEM_TYPE_REASONS = {
    FREIGHT: [
        'Product damaged in transit',
        'Product damaged at delivery',
        'Product lost in transit',
        'Product not returned',
        'Returned product damaged',
        'Product not assembled correctly',
        'Other',
    ],
    PROPERTY_DAMAGE: [
        'Property damaged - external',
        'Property damaged - internal',
        'Structural damage',
        'Floor damage (carpet, tile, wood, etc.)',
        'Other',
    ],
    SERVICE_FAILURE: [
        'Missed delivery date',
        'Missed delivery window',
        'Transit time too long',
        'No POD provided',
        'Service requested not provided',
        'Customer service issue at delivery',
        'Other',
    ],
};
